import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { decodeToken } from "../utils/authUtils";
import {DecodedToken} from "../interfaces/decodeToken";

interface ProjectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    project: any; // Idéalement, mieux typé avec une interface Project
}

const ProjectModal: React.FC<ProjectModalProps> = ({ isOpen, onClose, onSave, project }) => {
    const [numeroAdeme, setNumeroAdeme] = useState<string>('');
    const [error, setError] = useState<string>('');

    useEffect(() => {

        const token = sessionStorage.getItem('tokenAdminUI');
        if (token) {
            const decoded = decodeToken(token) as DecodedToken | null;
            console.log(decoded)
            if (decoded && decoded.sub) {
                //setIdUser(Number(decoded.sub));
            } else {
                toast.error('Impossible de récupérer l\'ID utilisateur.');
            }
        }

        if (project) {
            setNumeroAdeme(project.numeroAdeme);
        } else {
            resetFields();
        }
    }, [project]);

    const resetFields = () => {
        setNumeroAdeme('');
    };

    const handleSave = async () => {
        if (!numeroAdeme) {
            setError('Veuillez remplir tous les champs obligatoires.');
            toast.error('Veuillez remplir tous les champs obligatoires.');
            return;
        }

        setError('');

        try {
            if (project) {
                // Mettre à jour le projet
                //await updateProject(id, { idUser: idUser, id, code, libelle, numeroAdeme, classeEnergetiqueObj, classeEnergetiqueActuel, status, dateCreation, user, '',null,null,null,null,null,null,null, null,null,null,null,null,null,null,null });
                toast.success('Projet mis à jour avec succès !');
            } else {
                // Créer un nouveau projet
                //await createProject({ idUser: idUser, id, code, libelle, numeroAdeme, classeEnergetiqueObj, classeEnergetiqueActuel, status, dateCreation, user });
                toast.success('Projet créé avec succès !');
            }

            onSave();
            onClose();
        } catch (error) {
            toast.error('Erreur lors de la sauvegarde du projet.');
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-8 rounded-lg shadow-md max-w-lg w-full">
                    <h2 className="text-2xl font-bold mb-4">{project ? 'Modifier le projet' : 'Créer un projet'}</h2>

                    {error && <div className="text-red-500 mb-4">{error}</div>}

                    {
                        /*
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">
                            Libellé <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            className="p-2 border rounded-md w-full"
                            value={libelle}
                            onChange={(e) => setLibelle(e.target.value)}
                        />
                    </div>
                         */
                    }


                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">
                            N° Ademe <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            className="p-2 border rounded-md w-full"
                            disabled={project != null}
                            value={numeroAdeme}
                            onChange={(e) => setNumeroAdeme(e.target.value)}
                        />
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="bg-gray-300 text-black px-4 py-2 rounded-md mr-2"
                        >
                            Annuler
                        </button>
                        <button
                            onClick={handleSave}
                            className="bg-blue-500 text-white px-4 py-2 rounded-md "
                        >
                            {project ? 'Modifier' : 'Créer'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectModal;
